<script setup>
import { computed, inject } from 'vue'
import { imageCandidateWidths } from '../image-policy.js'
import { DEFAULT_IMAGE_DELIVERY, imageSource, imageUrl } from '../image-url.js'

const props = defineProps({
  src: { type: String, default: '' },
  sizes: { type: String, required: true },
  max_width: { type: Number, default: 960 },
  loading: { type: String, default: 'lazy' },
  fetchpriority: { type: String, default: 'auto' },
})
const config = inject('imageDelivery', DEFAULT_IMAGE_DELIVERY)
const source = computed(() => imageSource(props.src, config))
const candidates = computed(() => imageCandidateWidths(props.max_width))
const srcset = computed(() => source.value.provider === 'direct' ? undefined : candidates.value
  .map(width => `${imageUrl(source.value, width)} ${width}w`).join(', '))
const image_src = computed(() => source.value.url === '' ? undefined : imageUrl(source.value, Math.min(640, props.max_width)))
// auto uses actual layout size where supported; eager/LCP uses explicit sizes.
const image_sizes = computed(() => props.loading === 'lazy' ? `auto, ${props.sizes}` : props.sizes)
</script>

<template>
  <img :loading="loading" :fetchpriority="fetchpriority" decoding="async" :sizes="image_sizes" :srcset="srcset" :src="image_src">
</template>
